import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PopularCourseFeeStructureService} from '../../../shared/services/popular-course-fee-structure.service';

interface FeeStructureRow {
    universityName: string;
    universityLink: string;
    courseFees: string;
    feeDetails: string[];
}

import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';
@Component({
    selector: 'app-popular-course-fee-structure',
    templateUrl: './popular-course-fee-structure.component.html',
    styleUrls: ['./popular-course-fee-structure.component.scss']
})
export class PopularCourseFeeStructureComponent implements OnInit {
    public popularCourseId: any;
    submitting: any = false;
    dataExists: any = false;
    // Superseded by the rich table editor below (table_html) — kept commented out for now
    // in case the structured "Add University" table needs to come back.
    // tableRows: FeeStructureRow[] = [];
    editorBlocks: Array<{type: 'content' | 'table', value: string}> = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private activatedRoute: ActivatedRoute,
                private popularCourseFeeStructureService: PopularCourseFeeStructureService) {
    }

    ngOnInit(): void {
        this.popularCourseId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.popularCourseFeeStructureService.detailByAdmin(this.popularCourseId).subscribe(data => {
            this.dataExists = !!(data && data['info']);

            const blocks = (data && data['info']) ? UtilsService.splitEditorBlocks(data['info']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];

            // this.tableRows = (data && data['table_data'] && data['table_data'].length) ? data['table_data'] : [];
            // if (this.tableRows.length === 0) {
            //     this.addRow();
            // }
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    // addRow() {
    //     this.tableRows.push({universityName: '', universityLink: '', courseFees: '', feeDetails: ['']});
    // }
    //
    // removeRow(index: number) {
    //     this.tableRows.splice(index, 1);
    // }
    //
    // addFeeDetail(rowIndex: number) {
    //     this.tableRows[rowIndex].feeDetails.push('');
    // }
    //
    // removeFeeDetail(rowIndex: number, detailIndex: number) {
    //     this.tableRows[rowIndex].feeDetails.splice(detailIndex, 1);
    // }

    submit() {
        const info = UtilsService.joinEditorBlocks(this.editorBlocks);

        const params = {
            'info': info ? UtilsService.encodeHtml(info) : '',
            'table_html': ''
            // 'table_data': cleanedRows — commented out along with the structured table UI above
        };
        this.submitting = true;
        if (this.dataExists) {
            this.popularCourseFeeStructureService.updateByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        } else {
            this.popularCourseFeeStructureService.createByAdmin(this.popularCourseId, params).subscribe(data => {
                this.submitting = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
            });
        }
    }
}
